import { useEffect, useState } from 'react';
import { hasCookieConsent } from '../lib/storage';

export const useCookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!hasCookieConsent()) {
      setVisible(true);
    }
  }, []);

  return { visible, setVisible };
};
